import React, { useState } from "react";
import { Question, MultipleChoiceQuestion, Choice } from "./survey-types";
import QuestionTypeIcon from "./QuestionTypeIcon";

interface QuestionsListProps {
  questions: Question[];
  selectedQuestionIndex: number;
  setSelectedQuestionIndex: (index: number) => void;
}

const QuestionsList: React.FC<QuestionsListProps> = ({
  questions,
  selectedQuestionIndex,
  setSelectedQuestionIndex,
}) => {
  return (
    <ul>
      {questions.map((question, index) => (
        <li
          key={question.id}
          className={`mb-2 p-2 cursor-pointer ${
            index === selectedQuestionIndex
              ? "bg-slate-600 border"
              : "bg-slate-800"
          }`}
          onClick={() => setSelectedQuestionIndex(index)}
          style={{
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            maxHeight: "87px",
          }}
        >
          <QuestionTypeIcon type={question.type} />
          &nbsp;
          <span className="text-sm">
            {question.text ? (
              question.text
            ) : (
              <span className="text-slate-500">Empty question</span>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default QuestionsList;
